import { TABLET_MODE } from '@constants/size';
import styled from '@emotion/styled';
import { blue, white } from '@styles/Colors';
import { Radius } from '@styles/Radius';
import TimelineItem from '../TimelineItem';
import { TIMELINE_DATA } from './data';
import { useIsTablet } from '@hooks/responsive/useIsMobile';

type TimelineProps = {
  //
};

/** 회사소개서 - history 에 사용하는 Timeline 컴포넌트 */
export default function Timeline({}: TimelineProps) {
  const isTablet = useIsTablet();

  return (
    <TimeLineContainer>
      <TimeLineWapper>
        <TimeLine />
        <TimeLineContent>
          {TIMELINE_DATA.map((item, idx) => {
            const isLeft = idx % 2 === 0;
            return (
              <TimeLineBox key={item.title} isLeft={isLeft}>
                {!isTablet && (isLeft ? <TimelineItem item={item} /> : <EmptyBox />)}
                <Circle />
                {!isTablet ? isLeft ? <EmptyBox /> : <TimelineItem item={item} /> : <TimelineItem item={item} />}
              </TimeLineBox>
            );
          })}
        </TimeLineContent>
      </TimeLineWapper>
    </TimeLineContainer>
  );
}

const TimeLineContainer = styled.div`
  margin-top: 40px;
  position: relative;
`;

const TimeLine = styled.div`
  width: 2px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(73, 128, 247, 0) 0%,
    #4980f7 8.38%,
    #4980f7 89.42%,
    rgba(73, 128, 247, 0) 100%
  );

  position: absolute;
  left: 50%;
  transform: translateY(-50%, -50%);

  @media ${TABLET_MODE} {
    left: 0;
  }
`;

const TimeLineContent = styled.div`
  padding: 40px 0;

  display: grid;
  row-gap: 80px;
`;

const TimeLineWapper = styled.div<{ isLeft?: boolean }>`
  flex: 1;
  display: grid;
  row-gap: 16px;

  ${({ isLeft }) =>
    isLeft &&
    `
    text-align: right;
  `}
`;

const TimeLineBox = styled.div<{ isLeft?: boolean }>`
  display: flex;
  column-gap: 48px;
  position: relative;
  justify-content: ${({ isLeft }) => (isLeft ? 'flex-end' : 'flex-start')};

  ${({ isLeft }) =>
    isLeft &&
    `
    text-align: right;
  `}

  @media ${TABLET_MODE} {
    justify-content: flex-start;
    text-align: left;
  }
`;

const Circle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${blue.blue3};
  border-radius: ${Radius.MAXIMUM};
  background: ${white};

  position: relative;
  top: 8px;
  left: 1px;

  @media ${TABLET_MODE} {
    left: -8px;
  }
`;

const EmptyBox = styled.div`
  flex: 1;
`;
